import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
  selector: 'search-input',
  templateUrl: './search-input.component.html',
  styleUrls: ['./search-input.component.scss']
})
export class SearchInputComponent {
  @Input() placeholder: string = '';
  @Input() keyword: string = '';
  @Output() onSearch = new EventEmitter<string>();
  @Output() onPressed = new EventEmitter<KeyboardEvent>();
  @Output() onChanged = new EventEmitter<string>();

  search() {
    this.onSearch.emit(this.keyword);
  }

  keyPressed(e: KeyboardEvent) {
    this.onPressed.emit(e);
    if (e.key === 'Enter') {
      this.search();
    }
    this.onChanged.emit(this.keyword);
  }

  clear() {
    this.keyword = '';
    this.onChanged.emit(this.keyword);
  }
}
